import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
declare interface serverType {
	name: string;
	url: string;
	otimusClinicUrl?: string
	timezone?: string;
	socketPath?: string;
}
@Injectable({
	providedIn: 'root'
})
export class ServerUrlService {

	url: string = ''
	otimusClinicUrl: string = ''
	name: string = ''
	timezone: string = ''
	clients: serverType[]
	
	constructor(
		private router: Router
	) {
		this.clients = [
			{
				name: 'clinivida',
				url: 'https://clinivida.otimusclinic.com:9904'
			},
			{
				name: 'local',
				//url: 'https://local.otimusclinic.com:9902'
				url: 'http://localhost:2021'
			},
			// {
			// 	name: 'modelo',
			// 	url: 'https://modelo.otimusclinic.com:9902'
			// },
			{
				name: 'prontocord',
				url: 'https://prontocord.otimusclinic.com:9904',
				timezone: 'America/Manaus'
			},
			{
				name: 'salgadinho',
				url: 'https://salgadinho.otimusclinic.com:9906'
			},
			{
				name: 'uno',
				url: 'https://uno.otimusclinic.com:9906'
			},
			{
				name: 'bemdesaude',
				url: 'https://bemdesaude.otimusclinic.com:9904'
			},
			{
				name: 'augustos',
				url: 'https://augustos.otimusclinic.com:9902'
			},
			{
				name: 'gama',
				url: 'https://gama.otimusclinic.com:9902'
			},
			{
				name: 'sermed',
				url: 'https://sermed.otimusclinic.com:9902'
			},
			{
				name: 'lak',
				url: 'https://lak.otimusclinic.com:9901'
			},
			{
				name: 'lak-ag',
				url: 'https://lak-ag.otimusclinic.com:9901'
			},
			{
				name: 'prover',
				url: 'https://prover.otimusclinic.com:9902',
				timezone: 'America/Cuiaba'
			},
			{
				name: 'valemed',
				url: 'https://valemed.otimusclinic.com:9902',
				timezone: 'America/Cuiaba'
			},
			{
				name: 'mc',
				url: 'https://mc-nodeweb.otimusclinic.com'
			},
			{
				name: 'atenas',
				url: 'https://valemed.otimusclinic.com:9904'
			},
			{
				name: 'speedmeg',
				url: 'https://speedmeg.tzioncis.com.br:9902'
			},
			{
				name: 'clincenter',
				url: 'https://clincenter-nodeweb.otimusclinic.com'
			},
			{
				name: 'instamed',
				url: 'https://instamed.otimusclinic.com:9904'
			},
			{
				name: 'clincentermacae',
				url: 'https://clincentermacae-nodeweb.otimusclinic.com'
			},
			{
				name: 'clincenterguarus',
				url: 'https://clincenterguarus-nodeweb.otimusclinic.com'
			},
			{
				name: 'digimaxcacador',
				url: 'https://digimaxcacador.otimusclinic.com:9902'
			},
			{
				name: 'bmd',
				url: 'https://bmd-nodeweb.otimusclinic.com'
			},
			{
				name: 'maisnove',
				url: 'https://maisnove.otimusclinic.com:9906'
			},
			{
				name: 'samoc',
				url: 'https://samoc.otimusclinic.com:9907'
			},
			{
				name: 'neurologica',
				url: 'https://neurologica-nodeweb.otimusclinic.com'
			},
			{
				name: 'dressencial',
				url: 'https://dressencial-nodeweb.otimusclinic.com'
			},
			{
				name: 'litoral',
				url: 'https://litoral.otimusclinic.com:9906'
			},
			{
				name: 'bonito',
				url: 'https://bonito-nodeweb.otimusclinic.com'
			},
			{
				name: 'stem',
				url: 'https://stem.otimusclinic.com:9904'
			},
			{
				name: 'unirad',
				url: 'https://clinicaunirad.otimusclinic.com:9902'
			},
			{
				name: 'clinicaunirad',
				url: 'https://clinicaunirad.otimusclinic.com:9902'
			},
			{
				name: 'dfr',
				url: 'https://dfr.otimusclinic.com:9902'
			},
			{
				name: 'progastro',
				url: 'https://progastro.otimusclinic.com:9902'
			},
			{
				name: 'priori',
				url: 'https://priori.otimusclinic.com:9903'
			},
			{
				name: 'asl',
				url: 'https://asl-nodeweb.tzioncis.com.br'
			},
			{
				name: 'rioclaro',
				url: 'https://rioclaro.otimusclinic.com:9908'
			},
			{
				name: 'clinicaanimais',
				url: 'https://clinicaanimais-nodeweb.otimusclinic.com'
			},
			{
				name: 'multimed',
				url: 'https://multimed.otimusclinic.com.br:9902'
			}, 
			{
				name: 'localhost',
				url: 'http://localhost:9830',
				otimusClinicUrl: 'http://localhost:2022'
			}
		]
	}

	public getUrl = (): string => {
		// const url = window.location.pathname.split('/');
		// let baseurl = '';
		// this.clients.map((client) => {
		// 	if (client.name == url[1]) {
		// 		baseurl = client.url;
		// 	}
		// })
		// return baseurl;
    	return this.url
	}

	public getSocketPath = (): string => {
		const url = window.location.pathname.split('/');
		let socketPath = '';
		this.clients.map((client) => {
			if (client.name == url[1]) {
				socketPath = client.socketPath || '';
			}
		})
		return socketPath;
	}

	public getTimezone = (): string => {
		// const url = window.location.pathname.split('/');
		// let timeZone: string = '';
		// this.clients.map((client) => {
		// 	if (client.name == url[1]) {
		// 		timeZone = client.timezone || 'America/Sao_Paulo';
		// 	}
		// })
		// return timeZone;
		return this.timezone || 'America/Sao_Paulo'
	}

	public getName = (): string => {
		const url = window.location.pathname.split('/');
		return url[1];
	}

	public goTo(route: string): void {
		const client = this.getName()
		const goTo = route[0] === '/' ? route : `/${route}`
		this.router.navigate([`${client}${goTo}`])
	}

	public getHeader(): any {
		return {
			headers: {
				'Content-Type': 'application/json'
			}
		}
	}
}
